import { informants, methodSteps } from '@/mocks/siteContent';
import { SectionHead } from './kit';

export default function Sources() {
  return (
    <section id="sources" className="border-y border-background-200 bg-background-100/70">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <SectionHead
          index="叁"
          kicker="爆料人现身"
          title="截图之外，也听一手人怎么说"
          desc="人证无法代替事实，但能帮我们对截图口径做交叉验证。以下为匿名/化名接触者就本期热门网传消息的表态，均只代表个人立场，已做身份留档与倾向性标注。"
        />

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {informants.map((p) => (
            <figure
              key={p.uid}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <figcaption className="mb-5 flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-800">
                  <i className="ri-voiceprint-line text-lg" aria-hidden="true" />
                </span>
                <div>
                  <h3 className="font-heading text-sm font-bold text-foreground-950">{p.role}</h3>
                  <p className="text-[11px] text-foreground-500">编号 {p.uid}</p>
                </div>
              </figcaption>
              <blockquote className="relative flex-1 border-l-2 border-primary-300 pl-4 text-sm leading-relaxed text-foreground-800">
                <p>“{p.quote}”</p>
              </blockquote>
              <p className="mt-5 inline-flex items-center gap-2 text-xs text-foreground-600">
                <i
                  className={`${p.verified ? 'ri-checkbox-circle-line text-primary-600' : 'ri-time-line text-accent-600'} text-base`}
                  aria-hidden="true"
                />
                {p.strength}
              </p>
            </figure>
          ))}
        </div>

        <p className="mt-6 flex flex-col gap-1 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <i className="ri-information-line text-primary-600" aria-hidden="true" />
          <span>注：匿名口述仅供交叉验证，不构成定论；涉及个人权益内容一律不发布，欢迎爆料人以可信身份补充材料。</span>
        </p>
      </div>
    </section>
  );
}

export function Method() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
      <SectionHead
        index="肆"
        kicker="求证栏目信条"
        title="我们凭什么给网传消息下结论"
        desc="结论不是一拍脑袋，而是同一套流程跑下来的结果。这套方法对所有辟谣与实锤一视同仁，也欢迎你用来检验任何截图流出。"
      />
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {methodSteps.map((s) => (
          <div
            key={s.no}
            className="rounded-lg border border-background-200 bg-background-50 p-6"
          >
            <span className="mb-4 inline-flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 font-heading text-sm font-bold text-background-50">
              {s.no}
            </span>
            <h3 className="mb-2 font-heading text-base font-bold text-foreground-950">{s.title}</h3>
            <p className="text-sm leading-relaxed text-foreground-700">{s.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}